import { Button, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Switch, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { apiConstants, getGeneric, postGeneric } from '../../common/constants'
import * as React from 'react'
import PageTitle from "../PageTitle";
import { useSnackbar } from "notistack";
import Loader from "../../common/Loader";
import { useForm } from "react-hook-form";
import { FormProvider, RHFFileField, RHFSelectField } from "../../common/hook-form";
import { useGetAllActiveMerchantsIdCached2Query, useGetAllCourierPartnersCachedQuery } from "../../redux/commonApiCalls";
import _ from "lodash";
import ProzoDataGrid from "../../common/ProzoDataGrid";
import { Delete } from "@mui/icons-material";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup';
import DownloadSampleFile from "../DownloadSampleFile";
import { LoadingButton } from "@mui/lab";


function ConfigList() {
    const [sizePerPage, setSizePerPage] = useState(100);
    const [page, setPage] = useState(0);
    const [shouldFetch, setShouldFetch] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false);
    const [cardData, setCardData] = useState()
    const [merchantList, setMerchantList] = useState([])
    const [courierList, setCourierList] = useState([])
    const [configSlab, setConfigSlab] = useState([])
    const [slabValue, setSlabValue] = useState(null)
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const methods = useForm({
        resolver: yupResolver(Yup.object().shape({
            type: Yup.string()
                .required('Type is required'),
            merchant: Yup.string()
                .when('type', {
                    is: 'MERCHANT',
                    then: Yup.string().required('Merchant is required'),
                    otherwise: Yup.string().notRequired()
                }),
            courier: Yup.string()
                .when('type', {
                    is: 'COURIER',
                    then: Yup.string().required('Courier is required'),
                    otherwise: Yup.string().notRequired()
                }),
            typeMerchantCouriers: Yup.string()
                .when('type', {
                    is: 'MERCHANT',
                    then: Yup.string().required('Courier selection is required'),
                    otherwise: Yup.string().notRequired()
                })
        })),
        defaultValues: {
            type: '',
            merchant: '',
            courier: '',
            typeMerchantCouriers: '',
        }
    });
    const { handleSubmit, reset, watch } = methods

    const type = watch("type")
    const selectedMerchant = watch("merchant")
    const selectedCourier = watch("typeMerchantCouriers") // for type merchant
    const selectedCourierL = watch("courier") // for type courier


    const columns = [
        {
            field: 'startWeight',
            headerName: 'Start Weight',
            width: 150,
            flex: 1,
            align: 'left',
            renderCell: (col) => {
                return col.row.startWeight
            }
        },
        {
            field: "endWeight",
            headerName: "End Weight",
            width: 150,
            flex: 1,
            align: 'left',
            renderCell: (col) => {
                return col?.row?.endWeight
            }
        },
        {
            field: 'applicableWeight',
            headerName: 'Applicable Weight',
            width: 100,
            flex: 1,
            align: 'left',
        },
        {
            field: "variance",
            headerName: "Variance",
            width: 150,
            flex: 1,
            align: 'left',
        }
    ]


    const andfilter = [{ "field": "is_deleted", "operator": "eq", "value": '0' }];
    const filter = {
        "andfilter": andfilter,
        "offset": 0,
        "limit": 1000,
        // "controllerFilter": true,
        "skipCount": true,
        "includes": "id,name,cpAccountCode,prozoId,supportedShipmentType,isBlended"
        // "excludes": exclude,
    }
    const { data: couriers } = useGetAllCourierPartnersCachedQuery(filter);
    const { data: merchants = [] } = useGetAllActiveMerchantsIdCached2Query()

    const merchantNameFunc = (val) => {
        const filtertedMerchant = merchants.filter((data) => val?.includes(data.id))
        return filtertedMerchant
    }
    const courierNameFunc = (val) => {
        const filtertedCourier = couriers.filter((data) => val?.includes(data.id))
        return filtertedCourier
    }

    useEffect(() => {
        if (type === 'MERCHANT') {
            methods.setValue('merchant', '');
            methods.setValue('courier', '');
            methods.setValue('typeMerchantCouriers', '');
            setSlabValue(null);
            setMerchantList([]);
            setConfigSlab([]);
            getGeneric(`${apiConstants.DWS_MERCHANT_LIST}?category=MERCHANT`).then((res) => {
                setMerchantList(merchantNameFunc(res.data?.responseObj))
                setLoading(false)
            }).catch((err) => {
                console.log(err);
                setLoading(false)
            })
        } else if (type === 'COURIER') {
            methods.setValue('merchant', '');
            methods.setValue('courier', '');
            methods.setValue('typeMerchantCouriers', '');
            setSlabValue(null);
            setMerchantList([]);
            setConfigSlab([]);
            getGeneric(`${apiConstants.DWS_MERCHANT_LIST}?category=COURIER`).then((res) => {
                setCourierList(courierNameFunc(res.data?.responseObj))
                setLoading(false)
            }).catch((err) => {
                console.log(err);
                setLoading(false)
            })
        }
    }, [type])

    useEffect(() => {
        if (selectedMerchant) {
            getGeneric(`${apiConstants.DWS_LIST_BY_MERCHANT}?oid=${selectedMerchant}&category=MERCHANT`).then((res) => {
                if (res.status === 200 && res.data.status !== "ERROR") {
                    setConfigSlab(res?.data?.responseObj)
                } else {
                    setConfigSlab([])
                }
                setLoading(false)
            }).catch((err) => {
                console.log(err);
                setLoading(false)
            })
        }
    }, [selectedMerchant])

    const onSubmit = (val) => {
        setSearchLoading(true)
        getSlabDetails(val)
    }

    useEffect(() => {
        if (shouldFetch) {
            getSlabDetails();
            setShouldFetch(false); // Reset after fetching
        }
    }, [shouldFetch])



    const getSlabDetails = (val) => {
        if (type === 'MERCHANT') {
            getGeneric(`${apiConstants.DWS_BY_PROZOKEY}?oid=${selectedMerchant}&category=${type}&courierKey=${selectedCourier}`).then((res) => {
                setSlabValue(res?.data?.responseObj)
                setLoading(false)
            }).catch((err) => {
                console.log(err);
                setLoading(false)
            }).finally(() => setSearchLoading(false))
        }
        if (type === 'COURIER') {
            getGeneric(`${apiConstants.DWS_FOR_COURIER}?oid=${selectedCourierL}&category=${type}`).then((res) => {
                setSlabValue(res?.data?.responseObj?.[0])
                setLoading(false)
            }).catch((err) => {
                console.log(err);
                setLoading(false)
            }).finally(() => setSearchLoading(false))
        }
    }

    // Delete
    const handleCloseDelete = () => {
        setOpen(false)
        setDeleteConfirm(false)
    }

    const handleAgreeDelete = () => {
        let formData = new FormData();
        formData.append('category', type);
        formData.append('ownerOID', type === 'MERCHANT' ? selectedMerchant : selectedCourierL);
        postGeneric(apiConstants.DELETE_DWS_CONFIG, formData).then((res) => {
            setSlabValue(null)
            enqueueSnackbar('Successfully deleted!', { variant: 'success' })
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            reset()
            setDeleteConfirm(false);
            setOpen(false);
        })
    }

    const handleDelete = (val) => {
        setDeleteConfirm(true);
        setOpen(true);
    };

    // toggle

    const handleAgree = () => {
        let formData = new FormData();
        formData.append('category', type);
        formData.append('ownerOID', type === 'MERCHANT' ? selectedMerchant : selectedCourierL);
        formData.append('enabled', type === 'MERCHANT' ? !cardData.isActive[0] : !cardData.isActive);
        postGeneric(apiConstants.ENABLE_DISABLE_DWS_CONFIG, formData).then((res) => {
            if (res.status === 200 && res.data.status !== "ERROR") {
                setShouldFetch(true)
                enqueueSnackbar('Success!', { variant: 'success' })
            } else {
                enqueueSnackbar('Some error occurred!', { variant: 'error' })
            }
            setOpen(false);
            setCardData(null)
        }).catch((err) => {
            console.log(err);
        })
    }
    const toggleConfig = (val) => {
        setOpen(true);
        setCardData(val)
    };


    return (
        <div>
            {loading && <Loader />}
            <Dialog
                open={open}
                onClose={handleCloseDelete}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {""}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {!deleteConfirm ? "Are you sure you want to toggle Configuration ?" : "Are you sure you want to Delete ?"}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDelete}>No</Button>
                    <Button onClick={!deleteConfirm ? handleAgree : handleAgreeDelete}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            <PageTitle>DWS Configuration</PageTitle>
            <UploadDWSConfig />
            <Card sx={{ mb: 2 }}>
                <CardHeader
                    title={<Typography variant="h6" >Configuration Details</Typography>}
                    subheader={<Typography variant="body2" >Choose option below to view data.</Typography>} />
                <CardContent>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <RHFSelectField name="type" label="Type" width='100%' color="secondary" options={[
                                    { label: "Merchant", value: "MERCHANT" },
                                    { label: "Courier", value: "COURIER" },
                                ]} />
                            </Grid>
                            {type === "MERCHANT" &&
                                <Grid item xs={12} md={4}>
                                    <RHFSelectField width="100%" name="merchant" label={`Select Merchant`} options={_.orderBy(merchantList, "name").map((val) => ({
                                        value: val.id,
                                        label: val.name
                                    }))
                                    } />
                                </Grid>
                            }
                            {type === "COURIER" &&
                                <Grid item xs={12} md={4}>
                                    <RHFSelectField width="100%" name="courier" label={`Select Courier`} options={_.orderBy(courierList, "name").map((val) => ({
                                        value: val.id,
                                        label: val.name
                                    }))
                                    } />
                                </Grid>
                            }
                            {(selectedMerchant && type) &&
                                <Grid item xs={12} md={4}>
                                    <RHFSelectField width="100%" name="typeMerchantCouriers" label={`Select Courier`} options={configSlab?.map((val) => ({
                                        value: val,
                                        label: val
                                    }))
                                    } />
                                </Grid>
                            }
                            <Grid item xs={12} md={12} sx={{ mt: 1.5 }}>
                                <LoadingButton type="submit" variant="contained" loading={searchLoading} size="small">Search</LoadingButton>
                                <Button sx={{ ml: 1 }} variant="contained" size="small" color="error" onClick={() => {
                                    reset()
                                    setSlabValue(null)
                                    setMerchantList([])
                                    setConfigSlab([])
                                }}>Reset</Button>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </CardContent>
            </Card>
            {slabValue && (
                type === 'COURIER' 
                    ? (slabValue?.defaultSlabs?.length > 0)
                    : (slabValue?.[selectedCourier]?.length > 0)
            ) &&
                <Grid sx={{ paddingBottom: 2 }}>
                    <Card sx={{ mb: 2 }}>
                        <CardHeader title={<Typography variant="subtitle1">{type === 'MERCHANT' ? `${merchantNameFunc(selectedMerchant)[0]?.name} - (Merchant)` : `${courierNameFunc(selectedCourierL)[0]?.name} - (Courier)`}</Typography>}
                            action={
                                <>
                                    <Tooltip title={(type === 'MERCHANT' ? slabValue?.isActive?.[0] : slabValue?.isActive) ? "Disable" : "Enable"}>
                                        <Switch
                                            checked={(type === 'MERCHANT' ? slabValue?.isActive?.[0] : slabValue?.isActive) || false}
                                            onChange={() => { toggleConfig(slabValue) }}
                                            size='small'
                                        />
                                    </Tooltip>
                                    <Tooltip title="Delete DWS Config">
                                        <IconButton
                                            onClick={() => handleDelete()}
                                        >
                                            <Delete color="primary" size='small' />
                                        </IconButton>
                                    </Tooltip>
                                </>
                            }
                        />
                        <CardContent>
                            <ProzoDataGrid
                                columns={columns}
                                rows={type === 'MERCHANT' ? slabValue[selectedCourier]?.map((val, index) => ({ ...val, id: index })) : slabValue?.defaultSlabs?.map((val, index) => ({ ...val, id: index })) || []}
                                autoHeight={true}
                                hideFooterPagination={true}
                                sizePerPage={sizePerPage}
                                setSizePerPage={setSizePerPage}
                                setPage={setPage}
                                page={page}
                                paginationMode={'client'}
                                getRowId={(row) => row.id}
                                rowCount={Number.MAX_VALUE}
                            />
                        </CardContent>
                    </Card >
                </Grid>
            }
        </div >
    );
}
export default ConfigList;



const UploadDWSConfig = () => {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = useState(false)
    const { data: merchants = [] } = useGetAllActiveMerchantsIdCached2Query()


    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                type: Yup.string().required('Please select type'),
                file: Yup.mixed().required('Please select file'),
                merchant: Yup.string().when('type', {
                    is: 'MERCHANT',
                    then: Yup.string().required('Please select merchant'),
                    otherwise: Yup.string().notRequired(),
                }),
            })
        ),
        defaultValues: {
            merchant: '',
            type: '',
            file: null
        }
    });

    const { handleSubmit, reset, watch } = methods
    const onSubmit = (data) => {
        setIsLoading(true)
        const formData = new FormData();
        formData.append('file', data?.file[0]);
        formData.append("category", data.type);
        formData.append("merchantId", data.merchant);
        postGeneric(apiConstants.UPLOAD_DWS_CONFIG, formData).then((res) => {
            if (res.status === 200 && res.data?.status === "SUCCESS") {
                enqueueSnackbar('Successfully uploaded!', { variant: 'success' })
            } else {
                enqueueSnackbar(res.data?.errorMsg || 'Some error occurred', { variant: 'error' })
            }
            reset()
            setIsLoading(false)
        }).catch((err) => {
            console.log(err);
            enqueueSnackbar(err.response?.data?.message || 'Some error occurred', { variant: 'error' })
            setIsLoading(false)
        })
    }
    const SelectedType = watch('type')

    return (
        <>
            <Grid sx={{ paddingBottom: 2 }}>
                <Card>
                    <CardHeader
                        title={<Typography variant="h6">
                            {'Upload Config File'}
                        </Typography>}
                        subheader={<Typography variant="body2">
                            {'Select and upload your configuration file.'}
                        </Typography>}
                    />
                    <CardContent>
                        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <RHFSelectField name="type" label="Type" width='100%' color="secondary" options={[
                                        { label: "Merchant", value: "MERCHANT" },
                                        { label: "Courier", value: "COURIER" },
                                    ]}
                                    />
                                </Grid>
                                {SelectedType === "MERCHANT" && (
                                    <Grid item xs={12} md={4}>
                                        <RHFSelectField
                                            width="100%"
                                            name="merchant"
                                            label={`Select Merchant`}
                                            options={
                                                merchants.map((val) => ({
                                                    value: val.id,
                                                    label: val.name,
                                                }))
                                            }
                                        />
                                    </Grid>
                                )}
                                {(SelectedType === "MERCHANT" || SelectedType === "COURIER") && (
                                    <Grid item xs={12} md={4}>
                                        <RHFFileField name='file' required={true} />
                                    </Grid>
                                )}
                                <Grid item xs={12} md={12}>
                                    <LoadingButton loading={isLoading} type="submit" variant="contained" size="small">Upload</LoadingButton>
                                    <Button sx={{ ml: 1 }} variant="contained" size="small" color="error" onClick={() => {
                                        reset()
                                    }}>Reset</Button>
                                    <DownloadSampleFile fileName={"CUSTOM_DWS_CONFIG_SAMPLE"} label='SAMPLE' />
                                </Grid>
                            </Grid>
                        </FormProvider>
                    </CardContent>
                </Card>
            </Grid>
        </>
    )
}